import { Message } from 'view-design'

export const COURIER_STATE = {
    courier: {
        user: {
            success: false,
            error: false,
            visible: false,
            unreadCount: '0',
            type: '',
            visitorType: []
        },

        shop: {
            success: false,
            error: false,
            visible: false,
            unreadCount: '0',
            type: '',
            visitorType: [],
            shop: null
        },

        chatApply: {
            v: 0,
            clientType: '',
            visitorType: [],
            shopId: ''
        },

        restart: 0
    }
}

export const COURIER_MUTATIONS = {
    SET_COURIER_STATUS({ courier }, { type, status }) {
        Object.keys(status).forEach(key => {
            courier[type][key] = status[key]
        })
    },

    SET_COURIER_VISITOR_TYPE({ courier }, clientType) {
        courier[clientType].visitorType = [].concat(courier.chatApply.visitorType)
    },

    SET_COURIER_UNREAD_COUNT({ courier }, { type, count }) {
        courier[type].unreadCount = count + ''
    },

    SET_COURIER_APPLY({ courier }, chatApply) {
        courier.chatApply = chatApply
    },

    RESTART_COURIER({ courier }) {
        courier.user.success = false
        courier.user.error = false
        courier.user.visible = false
        courier.user.unreadCount = '0'
        courier.user.visitorType = []

        courier.shop.success = false
        courier.shop.error = false
        courier.shop.visible = false
        courier.shop.unreadCount = '0'
        courier.shop.visitorType = []
        courier.shop.shop = null

        courier.chatApply.v = 0
        courier.chatApply.clientType = ''
        courier.chatApply.visitorType = []
        courier.chatApply.shopId = ''

        courier.restart = courier.restart + 1 === 100 ? 0 : courier.restart + 1
    }
}

export const COURIER_ACTIONS = {
    setCourierStatus({ commit }, { type, status }) {
        commit('SET_COURIER_STATUS', { type, status })
    },

    setCourierVisitorType({ commit }, clientType) {
        commit('SET_COURIER_VISITOR_TYPE', clientType)
    },

    setCourierUnreadCount({ commit }, { type, count }) {
        commit('SET_COURIER_UNREAD_COUNT', { type, count })
    },

    plusCourierUnreadCount({ commit, state }, type) {
        const count = state.courier[type].unreadCount
        commit('SET_COURIER_UNREAD_COUNT', {
            type,
            count: count - 0 + 1 + ''
        })
    },

    consultCourierAdmin({ commit, state }) {
        const chatApply = state.courier.chatApply
        const { success, error } = state.courier.user

        if (error) {
            return Message.error('客服系统异常。')
        }
        if (!success) {
            return Message.warning('客服系统正在初始化，请稍后。')
        }
        commit('SET_COURIER_APPLY', {
            v: chatApply.v + 1 === 100 ? 0 : chatApply.v + 1,
            clientType: 'user',
            visitorType: ['4'],
            shopId: ''
        })
    },

    consultCourierShop({ commit, state }, shopId) {
        const chatApply = state.courier.chatApply
        const { success, error } = state.courier.user

        if (error) {
            return Message.error('客服系统异常。')
        }
        if (!success) {
            return Message.warning('客服系统正在初始化，请稍后。')
        }
        commit('SET_COURIER_APPLY', {
            v: chatApply.v + 1 === 100 ? 0 : chatApply.v + 1,
            clientType: 'user',
            visitorType: ['2', '3'],
            shopId
        })
    },

    restartCourier({ commit }) {
        commit('RESTART_COURIER')
    }
}
